import { useMemo } from 'react'
import { CustomTable, TableEmptyState } from 'app/components'
import { AtendimentoList } from 'app/modules/apps/atendimento/core/_models'
import { useQueryResponse } from '../core/QueryResponseProvider'
import { useQueryRequest } from '../core/QueryRequestProvider'
import { useListFilters } from '../core/ListFiltersProvider'
import { LogsConsultaColumns } from './columns/_columns'
import { useT } from '_metronic/i18n/Metronici18n'

export const LogsConsultaTable = () => {
  const { isLoading, isError, refetch, response } = useQueryResponse()
  const { hasFilters, clearFilters } = useListFilters()
  const { t } = useT()

  const columns = useMemo(() => LogsConsultaColumns(t), [t])

  const emptyState = hasFilters ? (
    <TableEmptyState
      title='Nenhum atendimento encontrado'
      description='Revise o paciente, o protocolo, o responsável ou a data.'
      action={{ label: 'Limpar filtros', onClick: clearFilters }}
    />
  ) : (
    <TableEmptyState
      title='Nenhum atendimento ainda'
      description='Os atendimentos aparecem aqui conforme forem solicitados.'
    />
  )

  return (
    <CustomTable<AtendimentoList>
      id='kt_table_consultas'
      ariaLabel='Atendimentos com logs'
      itemLabel={{ singular: 'atendimento', plural: 'atendimentos' }}
      data={response?.data || []}
      columns={columns}
      isLoading={isLoading}
      isError={isError}
      onRetry={refetch}
      emptyState={emptyState}
      queryHooks={{ useQueryRequest, useQueryResponse }}
    />
  )
}
